import { Avatar, Button, Menu, MenuItem } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { externalImageSrc } from "app/images";
import classNames from "classnames";
import { selectUserProfile } from "features/auth/auth";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { MenuLink } from "./MenuLink";
import { MenuLinkInfo } from "./useNavigationLinks";

const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: theme.spacing(4),
    },
    avatar: {
        borderRadius: theme.borderRadius.circular,
        width: 40,
        height: 40,
    },
    rotate: {
        transform: "rotate(180deg)",
        transition: "transform 0.3s ease",
    },
    menuItem: {
        "& .MuiLink-root": {
            color: theme.palette.grey700,
            fontWeight: 400,
        },
    },
}));

export const AccountMenu = (props: { links: MenuLinkInfo[] }) => {
    const [open, setOpen] = useState(false);

    const menuButtonRef = useRef(null);

    const classes = useStyles();
    const userProfile = useSelector(selectUserProfile);

    const renderMenuButton = (useRef: boolean) => (
        <Button
            color="secondary"
            onClick={() => setOpen((prev) => !prev)}
            ref={useRef ? menuButtonRef : undefined}
            data-testid="accountMenu"
        >
            <Avatar
                className={classes.avatar}
                alt={userProfile?.fullName}
                src={userProfile?.picture ? externalImageSrc(userProfile?.picture, 55) : undefined}
            >
                {userProfile?.fullName[0]}
            </Avatar>
            <ExpandMoreRoundedIcon className={classNames({ [classes.rotate]: open })} />
        </Button>
    );

    const renderMenu = () => {
        return (
            <Menu open={open} onClose={() => setOpen(false)} anchorEl={menuButtonRef.current}>
                {props.links.map((link) => (
                    <MenuItem
                        key={link.name}
                        onClick={() => setOpen(false)}
                        className={classes.menuItem}
                    >
                        <MenuLink link={link} />
                    </MenuItem>
                ))}
            </Menu>
        );
    };

    return (
        <div className={classes.root}>
            {renderMenuButton(true)}
            {renderMenu()}
        </div>
    );
};
